enum Web {
  SINGLE_SIGN_ON = 'web-react-sso',
  RENDERINGS_SIGNUP_BANNER = 'web-renderings-signup-banner',
  PROPERTY_DETAILS = 'web-property-details',
  JOB_SHARING_MVP = 'job-sharing-mvps',
  PROPERTY_DETAILS_PHOTOS_TAB = 'web-property-details-photos-tab',
  PAINT_MEASUREMENTS = 'GPAR-paint-measurement-report',
  JOBS_PAGE = 'jobs-page',
  HOMEOWNER_APP_PROJECTS = 'meow-projects',
  HOMEOWNER_APP_REDIRECT = 'web-react-homeowner-app-redirect',
  HOMEOWNER_APP_UPLOAD_TO_HYPERION = 'web-react-homeowner-app-upload-to-hyperion',
  ONBOARDING_P1_LOGIN = 'web-onboarding-phase-one-log-in',
  ONBOARDING_P1_SIGN_UP = 'web-onboarding-phase-one-sign-up',
  PRO_LANDING_PAGE = 'MEOW-pro-lead-landing-page',
  VIRTUAL_WALKTHROUGH = 'virtual-walkthrough',
  ONBOARDING_PHASE_1_SIGNIN_PASSWORD = 'web-onboarding-phase-one-sign-in-password',
  ONBOARDING_PHASE_1_SIGNUP_PASSWORD = 'web-onboarding-phase-one-sign-up-password',
  PRO_DESIGN_SHARING = 'pro-design-sharing',
}

enum Mobile {}

enum DesignStudio {
  DS_MACHETE_QUALITY = 'DS_macheteQualityTreatment',
  DS_MACHETE_USE_PRODUCTS_LIBRARY_FOR_TEXTURING = 'DS_useProductsLibraryForTexturingTreatment',
  DS_INSPIRE_ME = 'DS_inspire-me',
  HIGH_DEF_RENDERING_CTA = 'he_rendering-cta',
  DS_DOOR_GROUPS_DEBUGGING = 'design-studio-door-changing-debugging',
  DS_REAL_PRODUCTS_IN_TEMPLATES = 'design-studio-real-products',
  DS_REAL_PRODUCTS = 'design-studio-real-products-new-ui',
  DS_MUELLER_OPTIMIZATIONS = 'ds3d-mueller-optimizations',
  DS_SHOW_REAL_PRODUCTS_IN_GUEST_MODE = 'ds3d-guest-mode-new-ui',
}

enum AiDesigner {
  GML_POST_CAPTURE = 'AID_gml-post-capture',
}

enum FeatureTracking {
  RENDERING = 'rendering',
  AI_DESIGNER = 'ai-designer',
  INSPIRE_ME = 'inspire-me',
  HOMEOWNER_APP = 'homeowner-web-app',
  VIRTUAL_WALKTHROUGH = 'virtual-walkthrough',
}

enum Renderings {
  RENDERINGS_SHARE_CTA = 'he_renderings-hub-signup-cta',
  RENDERINGS_FOR_NEW_CONSTRUCTION = 'new-construction-additions',
}

enum NewConstruction {
  NEW_CONSTRUCTION_BUILD_ALL = 'new-construction-build-all-wizard-of-oz',
  MIXING_MATERIALS = 'commerce-mixing-materials',
  SHOW_ALL_MATERIAL_LISTS = 'show-all-material-lists',
}

enum Designer {
  ADVANCED_CUSTOMIZATION = 'web-react-advanced-customization',
  PROJECT_LINKOUTS = 'web-react-homeowner-project-linkouts',
  COMING_SOON = 'designer-feature-coming-soon',
}

const Value = {
  CONTROL: 'control',
  OFF: 'off',
  ON: 'on',
} as const;

const localhostFeaturesKey = 'local-split-features';

type LinkoutType = {
  buttonText: string;
  description: string;
  title: string;
  buttonHref: string;
  subtitle?: string;
  heroImage?: string;
};

// Note: These 2 are split across two feature flags because we were running into
// the maximum configuration of 1kb
export type ProjectLinkouts = {
  exploreServices: LinkoutType[];
  samplize: LinkoutType;
};

export type ComingSoonLinkouts = {
  comingSoon: LinkoutType;
  connectPro: LinkoutType;
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
type Value = (typeof Value)[keyof typeof Value];

type FeatureFlag =
  | DesignStudio
  | Renderings
  | Mobile
  | Web
  | AiDesigner
  | Designer
  | NewConstruction;

export type { FeatureFlag };
export {
  DesignStudio,
  Renderings,
  Mobile,
  Value,
  Web,
  localhostFeaturesKey,
  FeatureTracking,
  AiDesigner,
  Designer,
  NewConstruction,
};
